import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translate } from 'react-i18next'

import { Roles } from '../../config'
import { /* fetchProjectUsers, */ editProjectUsers } from '../../actions'
import Loading from '../Loading'

import { Form, Button, Select } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

const roleFormItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 6 }
}

class ProjectSettingsUsers extends Component {
  state = {
    // helper for Users multiselect field
    selectedProjectUsers: (this.props.project && _.keys(this.props.project.roles)) || null
  }

  // componentDidMount = () => {
  //   const { match: { params }, fetchProjectUsers } = this.props

  //   // fetchProjectUsers() also here in case user accessed the page via url / on refresh;
  //   // - this function is also called in Project.js
  //   fetchProjectUsers(params.projectId)
  // }

  handleUsersChange = values => {
    this.setState({ selectedProjectUsers: [...values] })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form, project, editProjectUsers, companies } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        if (project) {
          editProjectUsers(project.id, values, companies[project.companyId].users)
        }
      }
    })
  }

  render () {
    const { t, form: { getFieldDecorator }, project, loading, companies } = this.props
    const { selectedProjectUsers } = this.state

    // redux - wait for Company data
    if (!companies || !companies[project.companyId]) return <Loading />

    const company = companies[project.companyId]

    // generate users Options - for multi Select field
    const usersOptions = []
    _.map(company.users, (userData, userId) =>
      usersOptions.push(
        <Option key={userId} value={userId} title={userData.name_sync}>
          {userData.name_sync}
        </Option>
      )
    )
    // generate roles Options - used for selecting role for each of selected users
    const projectsRolesOptions = []
    _.map(Roles.PROJECT, (role, roleKey) =>
      // role > 0 && // use only roles lower than SuperAdmin
      projectsRolesOptions.push(
        <Option key={role} value={role}>
          {/* TODO: problem if value === 0 (SuperAdmin permission level) */}
          {t(`roles.${roleKey}`)}
        </Option>
      )
    )

    return (
      <Form onSubmit={this.handleSubmit}>

        <FormItem label='Users'>
          {getFieldDecorator('userIds', {
            initialValue: (project && _.keys(project.roles)) || null
          })(
            <Select
              mode='multiple'
              optionFilterProp='title'
              placeholder='Select Project users'
              onChange={this.handleUsersChange}
            >
              {usersOptions}
            </Select>
          )}
        </FormItem>

        {company.users &&
          selectedProjectUsers &&
          selectedProjectUsers.map(userId => (
            <FormItem
              // superadmin is saved only in 'projects/:projectId' doc
              label={company.users[userId] ? company.users[userId].name_sync : userId}
              {...roleFormItemLayout}
              key={userId}
            >
              {getFieldDecorator(`roles.${userId}`, {
                initialValue: project.roles && project.roles[userId],
                rules: [{ required: true, message: 'Project role is required' }]
              })(
                <Select placeholder='Project role'>
                  {projectsRolesOptions}
                </Select>
              )}
            </FormItem>
          ))}

        <FormItem>
          <Button htmlType='submit' type='primary' loading={loading.editProjectUsers}>
            Save
          </Button>
        </FormItem>

      </Form>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  nav: state.nav,
  loading: state.loading,
  user: state.user,
  companies: state.companies
  // projectUsers: state.projectUsers
})

const mapDispatchToParams = {
  // fetchProjectUsers,
  editProjectUsers
}

export default connect(mapStateToProps, mapDispatchToParams)(
  Form.create()(withRouter(translate('translations')(ProjectSettingsUsers)))
)



// WEBPACK FOOTER //
// ./src/components/ProjectSettings/ProjectSettingsUsers.js